


















import {
  Component, Mixins, PropSync, Watch,
} from 'vue-property-decorator';
import { Doughnut } from 'vue-chartjs';
import Chart from 'chart.js';
import ChartsUtil from '@/util/ChartUtils';
import StatsUtil from '@/util/StatsUtil';

@Component({})
export default class CategoryChart extends Mixins(Doughnut) {
  @PropSync('categoryLists', {}) categoryList!: any;

  @PropSync('marketSelected', {}) selectedMarket!: any;

  private chart: any;

  mounted() {
    this.generateChart(this.categoryList);
  }

  public generateChart(conf: any) {
    const ctx: any = document.getElementById('category-chart');
    const categoryLegendContainer = (this.$refs.categoryLegend as any);
    const categoryNoDataContainer = (this.$refs.categoryNoData as any);
    if (ctx) {
      if (!conf) {
        const config = this.getChartConfig(this.categoryList);
        if (this.chart) {
          this.chart.data.datasets = config.datasets;
          this.chart.data.labels = config.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(config.chartLabels,
              config.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(categoryNoDataContainer, categoryLegendContainer);
        }
      } else {
        const chartConfig = this.getChartConfig(conf);
        if (this.chart) {
          this.chart.data.datasets = chartConfig.datasets;
          this.chart.data.labels = chartConfig.chartLabels;
        } else {
          this.chart = new Chart(
            ctx,
            ChartsUtil.generateChartData(chartConfig.chartLabels,
              chartConfig.datasets),
          );
          this.chart.options.animation = ChartsUtil
            .getChartAnimation(categoryNoDataContainer, categoryLegendContainer);
        }
      }


      const myLegendContainer: any = document.getElementById('category-legend');
      myLegendContainer.innerHTML = this.chart.generateLegend();
      this.chart.update();
    }
  }

  public getChartConfig(list: any) {
    const { data } = list;
    const chartData = data.datasets[0]?.data;
    const chartLabels = data.labels;
    const datasets = [{
      backgroundColor: ['#f5b815', '#28ce17'],
      data: chartData,
    }];
    return {
      chartLabels,
      datasets,
    };
  }

  @Watch('categoryList')
  checkPartnerList(val: any) {
    this.generateChart(val);
  }
}
